import axios from 'axios';
import store from '../store/store';
import { logout } from '../store/slice/authSlice';

const getAxiosConfig = async ({ type }) => {
  const CancelToken = axios.CancelToken;
  const source = CancelToken.source();

   const reduxState = store.getState();

  const storedToken = reduxState.auth?.token;
  const storedUserProfileData = reduxState.userProfile?.userProfileData || {};

  const headers = {
    'Content-Type': 'application/json',
    'Authorization': storedToken ? `Bearer ${storedToken}` : '',
    'User-id': storedUserProfileData?.user_id || '',
    'User-role': storedUserProfileData?.role_info?.slug || '',
  };
  
  // console.log('--storedData', {headers, storedUserProfileData});
  let config = {
    baseURL: '', // optional: add baseURL if needed
    cancelToken: source.token,
    headers,
  };

  if (type === 'upload') {
    config = {
      ...config,
      onUploadProgress: (event) => {
        // Optional: handle upload progress
      },
    };
  } else if (type === 'download') {
    config = {
      ...config,
      responseType: 'blob', // Correct way for download
      onDownloadProgress: (event) => {
        // Optional: handle download progress
      },
    };
  }

  const axiosInstance = axios.create(config);

  // 🔹 Add response interceptor
  axiosInstance.interceptors.response.use(
    (response) => response,
    async (error) => {
      const status = error?.response?.status;
      const message = error?.response?.data?.message;

      if ((status === 401 || status === 402) && message?.includes("Unauthorized")) {
        console.log("🔴 Unauthorized → Logging out...");
        
        // clear auth data & redirect
        // store.dispatch(logoutSuccess());
        // store.dispatch(getUserProfileClean());
        // store.dispatch(loginClean());
        // mmkvStore.removeItem('loginData');
        // mmkvStore.clearAll();
        store.dispatch(logout());
      }

      return Promise.reject(error);
    }
  );

  return { axiosInstance, source, config };
};

const getFormattedError = (err) => {
  const { status, message, success } = err || {};
  return {
    success: success ?? false,
    status: status || 100,
    message: message || 'Network issue. Try again.',
    error: err
  };
};

const getRequest = () => ({ method: 'GET' });
const getRequestWithParams = (params) => ({ method: 'GET', params });
const postRequest = (params) => ({ method: 'POST', data: params });
const postFormRequest = (params) => ({
  method: 'POST',
  headers: { 'Content-Type': 'multipart/form-data' },
  data: params,
});
const postRequestWithParams = (params) => ({ method: 'POST', params });
const deleteRequest = (params) => ({ method: 'DELETE', data: params });

const callApi = async (url, options = {}, headerParams = {}) => {
  console.log('[callApi URL]:', url);
  console.log('[callApi Params]:', { url, headerParams, options });

  try {
    const finalHeaders = {
      ...options.headers,
      ...headerParams,
    };

    const res = await axios({
      url,
      ...options,
      headers: finalHeaders,
    });

    return res.data;
  } catch (error) {
    console.error('[callApi] Error:', error);
    return {
      isError: true,
      msg: error?.response?.data?.message || error.message || 'API call failed',
    };
  }
};

export {
  getAxiosConfig,
  getFormattedError,
  getRequest,
  getRequestWithParams,
  postRequest,
  postRequestWithParams,
  postFormRequest,
  deleteRequest,
  callApi,
};
